import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { queryClient } from '../queryClient';

export const useSendTransitGuaranteeRequest = () => {
  return apiClient.customer.sendTransitGuaranteeRequest.useMutation({
    onSuccess: (_: unknown, variables) => {
      queryClient.invalidateQueries({ queryKey: ['customer', variables.params.id] });
      toast.success('Guarantee info request sent successfully!');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Error sending transit guarantee access code!');
    },
  });
};
